import script from "./kxOnceImg2.vue?vue&type=script&setup=true&lang=js"
export * from "./kxOnceImg2.vue?vue&type=script&setup=true&lang=js"

import "./kxOnceImg2.vue?vue&type=style&index=0&id=78093aba&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78093aba"]])

export default __exports__